import * as React from 'react';
import { Label, SemanticCOLORS } from 'semantic-ui-react';
import * as styles from './LabelSpinner.scss';

interface Props {
    color: SemanticCOLORS;
    text: string;
}

const LabelSpinner: React.FC<Props> = ({ color, text }: Props) => (
    <Label color={color}>
        {text}
        <div className={styles.customDotSpinner}>
            <div />
            <div />
            <div />
        </div>
    </Label>
);

export default LabelSpinner;
